module.exports = __webpack_public_path__ + "static/img/1015_small.c9d7eb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1015_small.png
// module id = MxkS
// module chunks = 1